import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Timer from 'react-compound-timer';
import { showModal, clearModal, updateSectionTimer } from '../../store/actions/AssessmentActions';
import * as actions from '../../store/actions';
import { switchToNextSection } from '../../Utils/sectionUtils';
import { TRIGGER_TIMER } from '../../const';
import TimeEndedDisplay from './TimeEndedDisplay';
import useHeartbeat from '../../Utils/useHeartbeat';
import { HEARTBEAT_TYPE_SECTION } from '../../const';

const SectionTimer = ({ initialTime, submitTest }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const sections = useSelector(state => state.assessment.sections);
  const currentSectionId = useSelector(state => state.assessment.currentSectionId);
  const assessmentId = useSelector(state => state.invite.assessment_id);
  useHeartbeat(assessmentId, HEARTBEAT_TYPE_SECTION, currentSectionId);

  const sectionAutoComplete = () => {
    if (sections[sections.length - 1].id !== currentSectionId) {
      dispatch(
        showModal({
          name: 'submit_section',
          type: 'info',
          title: <TimeEndedDisplay />,
          content: 'Please proceed to the next section',
          onOk: () => dispatch(clearModal()),
        }),
      );
    }
    switchToNextSection({
      sections,
      currentSectionId,
      history,
      assessmentId,
      endBy: TRIGGER_TIMER,
      submitTest,
    });
  };

  useMemo(() => {
    if (initialTime <= 0) {
      sectionAutoComplete();
      dispatch(updateSectionTimer({ sectionId: currentSectionId, NaN }));
    }
  }, [currentSectionId, initialTime]);

  if (isNaN(initialTime)) {
    return <span>00:00:00</span>;
  } else if (initialTime <= 0) {
    return <span>Expired</span>;
  } else {
    return (
      <Timer
        key={`section-timer-${initialTime}`}
        initialTime={initialTime}
        direction="backward"
        formatValue={value => `${value < 10 ? `0${value}` : value}`}
        checkpoints={[
          {
            time: 0 * 60 * 1000,
            callback: () => sectionAutoComplete(),
          },
        ]}
      >
        {() => (
          <React.Fragment>
            <Timer.Hours /> : <Timer.Minutes /> : <Timer.Seconds />
          </React.Fragment>
        )}
      </Timer>
    );
  }
};

export default SectionTimer;
